/**
 * Режим ассистента — ряд сегментов «Авто · Ответ · Подсказка · Гид · Отчёт»
 * (agroai-6al.66; ранее — выпадающий список 6al.61). `radiogroup` + `radio`,
 * описание режима — в title. Активный сегмент залит, как у переключателя размера.
 */

import { Icon } from '../astra/ui/Icon';
import { defineMessages } from '../i18n/define';
import { useT } from '../i18n/hooks';

const m = defineMessages({
  aria: { id: 'ai.modes.aria', defaultMessage: 'Режим ассистента', description: 'Подпись для экранного диктора: ряд кнопок выбора режима ИИ-помощника (Авто, Ответ, Подсказка, Гид, Отчёт)' },
});

export interface ModeOption<T extends string> {
  id: T;
  label: string;
  hint: string;
  icon: Parameters<typeof Icon>[0]['icon'];
}

export function ModePicker<T extends string>({
  mode,
  options,
  disabled,
  onChange,
}: {
  mode: T;
  options: ModeOption<T>[];
  disabled?: boolean;
  onChange: (next: T) => void;
}) {
  const t = useT();
  return (
    <div className="agent-modes" role="radiogroup" aria-label={t(m.aria)}>
      {options.map((item) => (
        <button
          key={item.id}
          type="button"
          role="radio"
          aria-checked={mode === item.id}
          aria-label={item.label}
          className={`agent-mode focus-ring${mode === item.id ? ' agent-mode--on' : ''}`}
          title={item.hint}
          disabled={disabled}
          onClick={() => onChange(item.id)}
        >
          <Icon icon={item.icon} size={16} />
          <span className="agent-mode__label">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
